import { render, staticRenderFns } from "./MessageCardSelector.vue?vue&type=template&id=3e1c2b38&lang=pug&"
import script from "./MessageCardSelector.vue?vue&type=script&lang=ts&"
export * from "./MessageCardSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports